import React, { useState } from "react";
import { Button, Col, Divider, Form, Modal, Row, Spin, Table, Typography, Tooltip } from "antd";
import TextArea from "antd/es/input/TextArea";
import styles from "../../../../../assets/styles/styles";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import { PlusCircleOutlined, EditOutlined, EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { apiConfig, labelConfig } from "../../../customer.config";
import Notiflix from "notiflix";
import { useNavigate } from "react-router-dom";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";
const { Text, Title } = Typography;

const Memo = (props) => {
  const { memoList, state, useForm, userData, setMemoList, getNotes } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleMemoDelete = (key) => {
    let action = "Delete  ";
    let label = "Memo";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const url = `${apiConfig.Savings}/${state.id}/notes/${key.memoId}`;
        let body = {
          session,
          method: "DELETE",
        };
        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              //STOP LOAD
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteMemoMsg);

              getNotes();
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              getNotes();
              setIsLoading(false);
            },
          }
        );
      },

      function () {
        // No button
      }
    );
  };

  const columns = [
    {
      title: "Memo ID",
      dataIndex: "memoId",
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
    },
    {
      title: "Memo",
      dataIndex: "memo",
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
    },
    {
      title: "Actions",
      render: (_, record) => (
        <>
          <EditMemo
            currentCustomerObj={state}
            userData={userData}
            memoObj={record}
            setMemoList={setMemoList}
            memoList={memoList}
            refreshMemoList={getNotes}
          />
          &nbsp;
          <Tooltip title={`Delete`}>
            {BOM.HasPermission("DELETE_SAVINGNOTE") && (
              <Button
                type="primary"
                icon={<DeleteOutlined />}
                onClick={() => handleMemoDelete(record)}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
              />
            )}
          </Tooltip>
        </>
      ),
    },
  ];

  return (
    <>
      <Row>
        <NewMemo
          useForm={useForm}
          userData={userData}
          state={state}
          refreshMemoList={getNotes}
          currentCustomerObj={state}
        />
      </Row>
      <Col span={24}>
        <Table columns={columns} dataSource={memoList} />;
      </Col>
    </>
  );
};

export default Memo;

const NewMemo = (props) => {
  const navigate = useNavigate();
  const { useForm, userData, currentCustomerObj, notesList, refreshMemoList } = props;
  const { session } = userData;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = (formValues) => {
    const url = `${apiConfig.Savings}/${currentCustomerObj.id}/notes`;

    const body = {
      ...formValues,
      method: "POST",
      session,
    };

    setIsLoading(true);

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newMemoMsg);
          // close modal
          setIsModalOpen(false);
          refreshMemoList();
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          refreshMemoList();
          setIsLoading(false);
          setIsModalOpen(false);
        },
      }
    );
  };

  return (
    <>
      {BOM.HasPermission("CREATE_SAVINGNOTE") && (
        <Button type="primary" shape="round" className="of-primaryBtnColor" onClick={showModal}>
          <PlusCircleOutlined />
          &nbsp;{labelConfig.add}
        </Button>
      )}
      <Modal
        title="New Memo"
        open={isModalOpen}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onSubmit}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Saving..." size="large">
          <Divider />

          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item name={"note"}>
                <TextArea
                  style={{ width: "45vh", height: "15vh" }}
                  placeholder="Please enter a note"
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};

const EditMemo = (props) => {
  const navigate = useNavigate();
  const { currentCustomerObj, userData, memoObj, setMemoList, memoList, refreshMemoList } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
    // getTemplate();
  };

  React.useEffect(() => {
    if (!memoObj) return;
    useForm.setFieldsValue({
      note: memoObj.memo,
    });
  }, [memoObj]);

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = (formValues) => {
    const url = `${apiConfig.Savings}/${currentCustomerObj.id}/notes/${memoObj.memoId}`;

    const body = {
      ...formValues,
      method: "PUT",
      session,
    };

    setIsLoading(true);
    // return
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.editMemoMsg);

          // setMemoList([...memoList, (memoObj.memo = res.changes.note)]);
          // close modal
          setIsModalOpen(false);

          //refresh the list
          refreshMemoList();

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          refreshMemoList();
          setIsLoading(false);
          setIsModalOpen(false);
        },
      }
    );
  };

  return (
    <>
      <Tooltip title={`Edit`}>
        {BOM.HasPermission("UPDATE_SAVINGNOTE") && (
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={showModal}
            shape="round"
            size="small"
            className="of-primaryBtnColor"
          />
        )}
      </Tooltip>
      <Modal
        title="Edit Memo"
        open={isModalOpen}
        okText="Submit"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onSubmit}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item name={"note"}>
                <TextArea
                  style={{ width: "45vh", height: "15vh" }}
                  placeholder="Please enter a note"
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};
